import type { IEmailBuilderMediaItem } from "api/rpc/2024-04/facilityAdmin/marketing/emailBuilderTypes";
import { isFacilityLogoMediaRef, registerEmailBuilderLibraryMediaSource } from "../domain/media";
import type { ImageBlock, MediaRef } from "../domain/types";
import { EMAIL_BUILDER_FACILITY_LOGO_MEDIA_ID } from "./emailBuilderMediaAdapter";

export function emailBuilderMediaItemToMediaRef(
  media: IEmailBuilderMediaItem,
): MediaRef {
  if (media.id === 0) {
    return { kind: "facility", assetKey: "logo" };
  }

  registerEmailBuilderLibraryMediaSource(media.id, media.source);
  return { kind: "library", mediaId: String(media.id) };
}

export function imageBlockPatchFromEmailBuilderMediaItem(
  media: IEmailBuilderMediaItem,
): Pick<ImageBlock, "media" | "intrinsicSize"> {
  return {
    media: emailBuilderMediaItemToMediaRef(media),
    intrinsicSize: null,
  };
}

export function resolveMediaRefMediaId(ref: MediaRef | null): number | null {
  if (ref?.kind === "library") {
    const parsed = Number.parseInt(ref.mediaId, 10);
    return Number.isFinite(parsed) ? parsed : null;
  }
  if (isFacilityLogoMediaRef(ref)) {
    return EMAIL_BUILDER_FACILITY_LOGO_MEDIA_ID;
  }
  return null;
}
